import { withParams } from 'vuelidate';
export default withParams({ type: 'accountNumberLength18Or24Digit' }, (value) => {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}
	let valueLength = value.replace(/\D/g, '').length;
	if (valueLength == 16 || valueLength == 24) {
		return true;
	}
	return false;
});
